module.exports = __webpack_public_path__ + "static/media/ie.3214e531.svg";